import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { ModalWrapper } from 'src/components/modal-wrapper'
import { IUserSessionFormValues } from 'src/types'
import { createFormData } from '../utils'

import { useStyles } from './styles'
import { SessionIcon } from 'src/assets/icons/v2/SessionIcon'
import { MapPinIcon } from 'src/assets/icons/v2/MapPinIcon'
import { EmptyUserIcon } from 'src/assets/icons/v2/EmptyUserIcon'
import { LanguageIcon } from 'src/assets/icons/v2/LanguageIcon'
import { MapIcon } from 'src/assets/icons/v2/MapIcon'
import { UserAgentIcon } from 'src/assets/icons/v2/UserAgentIcon'

interface IProps {
  open: boolean
  handleClose: () => void
  formValues: IUserSessionFormValues
}

const UserSessionFormModal = ({ open, handleClose, formValues }: IProps) => {
  const classes = useStyles()

  if (!formValues) {
    return null
  }

  return (
    <ModalWrapper open={open} className={classes.modalWrapper} onClose={handleClose}>
      <div className={classes.tableHeader}>
        <SessionIcon size={80} />
        <Typography className={classes.title}>
          <HelperWrapper t="user-session-form-title" />
        </Typography>
      </div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell width="30%" align="center">
                <HelperWrapper t="change-logs-field-column" />
              </TableCell>
              <TableCell width="90%" align="center">
                <HelperWrapper t="error-logs-value-column" />
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell component="td" scope="row">
                <div className={classes.cellDisplay}>
                  <MapPinIcon size={20} />
                  <div> IP-Address:</div>
                </div>
              </TableCell>
              <TableCell>{formValues.ip_address || <EmptyUserIcon size={24} />}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="td" scope="row">
                <div className={classes.cellDisplay}>
                  <LanguageIcon size={20} />
                  <div>Language:</div>
                </div>
              </TableCell>
              <TableCell>{formValues.accept_language || <EmptyUserIcon size={24} />}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="td" scope="row">
                <div className={classes.cellDisplay}>
                  <UserAgentIcon size={20} />
                  <div>User agent:</div>
                </div>
              </TableCell>
              <TableCell>{formValues.user_agent || <EmptyUserIcon size={24} />}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="td" scope="row">
                <div className={classes.cellDisplay}>
                  <MapIcon size={20} />
                  <div>IP-Country:</div>
                </div>
              </TableCell>
              <TableCell>{formValues.ip_country || <EmptyUserIcon size={24} />}</TableCell>
            </TableRow>
            {/* {createFormData(formValues).map((row) => (
              <TableRow key={row.field} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell className={classes.fieldRow} component="th" scope="row">
                  {row.field}
                </TableCell>
                <TableCell>{row.value}</TableCell>
              </TableRow>
            ))} */}
          </TableBody>
        </Table>
      </TableContainer>
    </ModalWrapper>
  )
}

export { UserSessionFormModal }
